import { auth } from "@/firebaseInit"

export default function guest ({ next}){
    auth.onAuthStateChanged(user => {
        if(user){
            return next({
               name: 'dashboard'
            })
        }
       
        return next()
      });
    
   }